import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api, fileUrl } from "../lib/api";

export default function ArticleView() {
  const { slug, article_id } = useParams();
  const [a, setA] = useState(null);
  const [w, setW] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/articles/${article_id}`).then(r => setA(r.data)).catch(() => navigate(`/w/${slug}`));
    api.get(`/websites/public/${slug}`).then(r => setW(r.data)).catch(() => {});
  }, [article_id, slug]);

  if (!a || !w) return null;
  const brand = w.primary_color;

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b bg-white">
        <div className="max-w-7xl mx-auto px-4 py-4 text-center">
          <Link to={`/w/${slug}`}><h1 className="text-3xl font-black font-bn" style={{ color: brand }}>{w.name}</h1></Link>
        </div>
      </header>
      <article className="max-w-3xl mx-auto px-4 py-10">
        <div className="text-xs font-black uppercase text-rose-600">{a.category}</div>
        <h1 className="mt-2 text-3xl sm:text-5xl font-black leading-tight font-bn">{a.title}</h1>
        <div className="mt-3 text-sm text-slate-500">By <span className="font-semibold">{a.author}</span> · 👁 {a.views}</div>
        {a.featured_image && <img src={fileUrl(a.featured_image)} className="w-full aspect-video object-cover rounded-xl mt-6" alt=""/>}
        {a.excerpt && <p className="mt-6 text-xl text-slate-600 font-bn leading-relaxed">{a.excerpt}</p>}
        <div className="mt-6 prose whitespace-pre-line text-slate-800 font-bn text-lg leading-relaxed">{a.body}</div>
      </article>
      <footer className="border-t py-8 text-center text-sm text-slate-500">
        © 2026 {w.name} · <Link to="/" className="text-rose-600 font-semibold">OxyCom</Link>
      </footer>
    </div>
  );
}
